// extracted by mini-css-extract-plugin
module.exports = {"Base":"Base--2kg4s","Group":"Group--1skER"};